<div class="card mt-3">
  <div class="card-body">
    <h3 class="mb-4">{{ 'MENU.DASHBOARD.edit_investor' | translate }}</h3>

    <!-- Loading Indicator -->
    <div *ngIf="isLoading" class="text-center py-4">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <form (ngSubmit)="updateProduct()" enctype="multipart/form-data" #editForm="ngForm" *ngIf="!isLoading">
      
      <!-- Image Upload Section -->
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <div class="file-upload-container">
              <input 
                type="file" 
                id="logoUpload" 
                accept="image/*" 
                (change)="onFileSelected($event)"
                #imageInput
              >
              <div class="file-upload-label">
                <i class="fas fa-cloud-upload-alt file-upload-icon"></i>
                <div class="file-upload-text">{{ 'MENU.DASHBOARD.click_to_upload_imageEmp' | translate }}</div>
                <div class="file-upload-text">{{ 'MENU.DASHBOARD.drag_drop_image' | translate }}</div>
                <div class="form-hint">{{ 'MENU.DASHBOARD.recommended_size' | translate }}</div>
              </div>
            </div>
            
            <div class="no-preview" *ngIf="!product.image">
              <div class="form-hint">{{ 'MENU.DASHBOARD.no_imageEmp_uploaded' | translate }}</div>
            </div>
          </div>
        </div>

        <!-- Image Preview -->
        <div class="col-6">
          <div class="image-preview-container" *ngIf="product.image">
            <div class="image-preview-header">
              <h6>{{ 'MENU.DASHBOARD.image_preview' | translate }}</h6>
              <button type="button" class="btn-close" (click)="removeImage()" aria-label="Close"></button>
            </div>
            <div class="image-preview">
              <img [src]="product.image" alt="Preview" class="preview-image">
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <!-- Name -->
        <div class="col-sm-4">
          <div class="mb-3">
            <label class="form-label required-field">{{ 'MENU.DASHBOARD.name' | translate }}</label>
            <input
              type="text"
              class="form-control"
              [class.is-invalid]="name.invalid && name.touched"
              placeholder="{{ 'MENU.DASHBOARD.enter_name' | translate }}"
              [(ngModel)]="product.name"
              name="name"
              #name="ngModel"
              required
              minlength="2"
              maxlength="50"
            />
            <div *ngIf="name.invalid && name.touched" class="text-danger small mt-1">
              <div *ngIf="name.errors?.['required']">{{ 'MENU.VALIDATION.name_required' | translate }}</div>
              <div *ngIf="name.errors?.['minlength']">{{ 'MENU.VALIDATION.name_min_length' | translate }}</div>
            </div>
          </div>
        </div>

        <!-- Email -->
        <div class="col-sm-4">
          <div class="mb-3">
            <label class="form-label">{{ 'MENU.DASHBOARD.email' | translate }}</label>
            <input
              type="email"
              class="form-control"
              [class.is-invalid]="email.invalid && email.touched"
              placeholder="{{ 'MENU.DASHBOARD.enter_email' | translate }}"
              [(ngModel)]="product.email"
              name="email"
              #email="ngModel"
              email
            />
            <div *ngIf="email.invalid && email.touched" class="text-danger small mt-1">
              <div *ngIf="email.errors?.['email']">{{ 'MENU.VALIDATION.email_invalid' | translate }}</div>
            </div>
          </div>
        </div>

        <!-- Phone -->
        <div class="col-sm-4">
          <div class="mb-3">
            <label class="form-label required-field">{{ 'MENU.DASHBOARD.phone' | translate }}</label>
            <input
              type="text"
              class="form-control"
              [class.is-invalid]="phone.invalid && phone.touched"
              placeholder="{{ 'MENU.DASHBOARD.enter_phone' | translate }}"
              [(ngModel)]="product.phone"
              name="phone"
              #phone="ngModel"
              required
              pattern="^(05[0-9]{8}|5[0-9]{8}|9665[0-9]{8}|009665[0-9]{8}|\+9665[0-9]{8})$"
              maxlength="14"
            />
            <div *ngIf="phone.invalid && phone.touched" class="text-danger small mt-1">
              <div *ngIf="phone.errors?.['required']">{{ 'MENU.VALIDATION.phone_required' | translate }}</div>
              <div *ngIf="phone.errors?.['pattern']">{{ 'MENU.VALIDATION.saudi_phone_only' | translate }}</div>
            </div>
            <div class="form-text text-muted">
              <small>الأشكال المقبولة: 05XXXXXXXX, 5XXXXXXXX, 9665XXXXXXXX</small>
            </div>
          </div>
        </div>

        <!-- ID Number -->
        <div class="col-sm-6">
          <div class="mb-3">
            <label class="form-label required-field">{{ 'MENU.DASHBOARD.id_number' | translate }}</label>
            <input
              type="text"
              class="form-control"
              [class.is-invalid]="identityNumber.invalid && identityNumber.touched"
              placeholder="{{ 'MENU.DASHBOARD.enter_id_number' | translate }}"
              [(ngModel)]="product.identity_number"
              name="identity_number"
              #identityNumber="ngModel"
              required
              pattern="^[0-9]{10}$"
              maxlength="10"
            />
            <div *ngIf="identityNumber.invalid && identityNumber.touched" class="text-danger small mt-1">
              <div *ngIf="identityNumber.errors?.['required']">{{ 'MENU.VALIDATION.id_number_required' | translate }}</div>
              <div *ngIf="identityNumber.errors?.['pattern']">{{ 'MENU.VALIDATION.id_number_format' | translate }}</div>
            </div>
          </div>
        </div>

        <!-- Nationality -->
        <div class="col-sm-6">
          <div class="mb-3">
            <label class="form-label required-field">{{ 'MENU.DASHBOARD.nationality' | translate }}</label>
            <select
              class="form-control"
              [class.is-invalid]="nationality.invalid && nationality.touched"
              [(ngModel)]="product.nationality"
              name="nationality"
              #nationality="ngModel"
              (change)="onNationalityChange()"
              required
            >
              <option value="" disabled>{{ 'MENU.DASHBOARD.select_nationality' | translate }}</option>
              <option *ngFor="let country of countries" [value]="country.id">
                {{ country.name }}
              </option>
            </select>
            <div *ngIf="nationality.invalid && nationality.touched" class="text-danger small mt-1">
              <div *ngIf="nationality.errors?.['required']">{{ 'MENU.VALIDATION.nationality_required' | translate }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <!-- City -->
        <div class="col-sm-6">
          <div class="mb-3">
            <label class="form-label required-field">{{ 'MENU.DASHBOARD.city' | translate }}</label>
            <select
              class="form-control"
              [class.is-invalid]="city_id.invalid && city_id.touched"
              [(ngModel)]="product.city_id"
              name="city_id"
              #city_id="ngModel"
              required
            >
              <option value="" disabled>{{ 'MENU.DASHBOARD.select_city' | translate }}</option>
              <option *ngFor="let city of cities" [value]="city.id" >
                {{ city.name }}
              </option>
            </select>
            <div *ngIf="city_id.invalid && city_id.touched" class="text-danger small mt-1">
              {{ 'MENU.VALIDATION.city_required' | translate }}
            </div>
            <div *ngIf="product.nationality && cities.length === 0" class="text-info small mt-1">
              {{ 'MENU.DASHBOARD.loadin' | translate }}
            </div>
            <div *ngIf="!product.nationality" class="text-info small mt-1">
              {{ 'MENU.DASHBOARD.select_nationality_first' | translate }}
            </div>
          </div>
        </div>

        <!-- Employee -->
        <div class="col-sm-6">
          <div class="mb-3">
            <label class="form-label required-field">{{ 'MENU.DASHBOARD.employee' | translate }}</label>
            <select
              class="form-control"
              [class.is-invalid]="employee_id.invalid && employee_id.touched"
              [(ngModel)]="product.employee_id"
              name="employee_id"
              #employee_id="ngModel"
              required
            >
              <option value="" disabled>{{ 'MENU.DASHBOARD.select_employee' | translate }}</option>
              <option *ngFor="let item of employee" [value]="item.id">
                {{ item?.name }}
              </option>
            </select>
            <div *ngIf="employee_id.invalid && employee_id.touched" class="text-danger small mt-1">
              {{ 'MENU.VALIDATION.employee_required' | translate }}
            </div>
          </div>
        </div>
      </div>

      <!-- Submit Button -->
      <div class="text-start mt-3">
        <button 
          type="submit" 
          class="btn btn-success px-4 mx-2" 
          style="background-color: #cca44c !important;"
          [disabled]="isLoading"
        >
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
          {{ 'MENU.DASHBOARD.save_changes' | translate }}
        </button>
        
        <button 
          type="button" 
          class="btn btn-secondary ms-2 px-4"
          (click)="router.navigate(['/investors'])"
          [disabled]="isLoading"
        >
          {{ 'MENU.DASHBOARD.cancel' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
